"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Card_1 = require("./Card");
exports.AdsManagerBrochureAdTearSheets = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.AdsManagerBrochureCard, { title: "Tear Sheets", accentColor: "#B66D3C", description: "See past runs of ad campaigns, and get reporting." },
            react_1.default.createElement(Card_1.AdsManagerBrochureCard.Feature, { icon: "success" }, "Give advertisers confidence that their campaigns have ran."),
            react_1.default.createElement(Card_1.AdsManagerBrochureCard.Feature, { icon: "show" }, "See exactly how ads appeared when they ran."),
            react_1.default.createElement(Card_1.AdsManagerBrochureCard.Feature, { icon: "analytics" }, "Measure performance using click-through rates and impressions."))));
};
//# sourceMappingURL=AdTearSheets.js.map